import { render } from "./ContactVue.vue?vue&type=template&id=3ea716df"
import script from "./ContactVue.vue?vue&type=script&lang=js"
export * from "./ContactVue.vue?vue&type=script&lang=js"

import "./ContactVue.vue?vue&type=style&index=0&id=3ea716df&lang=css"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__